import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Query Project Data
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestQueryProjectData = packet => {
  return {
    type: 'REQUEST_QUERY_PROJECT_DATA',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveQueryProjectDataSuccess = data => ({
  type: 'RECEIVE_QUERY_PROJECT_DATA_SUCCESS',
  data
})

export const receiveQueryProjectDataFail = data => ({
  type: 'RECEIVE_QUERY_PROJECT_DATA_FAIL',
  data
})

export const tryToQueryProjectData = packet => (dispatch, getState) => {

  dispatch(requestQueryProjectData(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  
  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }

  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/query/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveQueryProjectDataSuccess({
        cacheID: packet.cacheID,
        data: json
      }));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveQueryProjectDataFail({errors:e, lastSubmit: packet}));
    })
}
